var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4685 4.58568C22.7919 4.32692 22.8444 3.85495 22.5856 3.53151C22.3269 3.20806 21.8549 3.15562 21.5314 3.41438L18.2061 6.07464C18.0245 5.91151 17.8385 5.75148 17.6482 5.59574C16.0767 4.30902 14.1409 3.25003 12 3.25003C9.85902 3.25003 7.92322 4.30902 6.3517 5.59574C4.7716 6.88949 3.47959 8.47868 2.61138 9.68804L2.53978 9.78762C2.01712 10.5139 1.58688 11.1117 1.58688 12C1.58688 12.8884 2.01712 13.4862 2.53978 14.2124L2.61138 14.312C3.15604 15.0707 3.86748 15.9788 4.71221 16.8698L1.53145 19.4144C1.208 19.6731 1.15556 20.1451 1.41431 20.4685C1.67307 20.792 2.14504 20.8444 2.46849 20.5857L22.4685 4.58568ZM8.66172 13.7102L9.87446 12.74C9.7938 12.5082 9.74997 12.2592 9.74997 12C9.74997 10.7574 10.7573 9.75003 12 9.75003C12.4362 9.75003 12.8434 9.87415 13.1882 10.089L14.4006 9.11904C13.7502 8.57647 12.9132 8.25003 12 8.25003C9.9289 8.25003 8.24997 9.92896 8.24997 12C8.24997 12.6161 8.39851 13.1974 8.66172 13.7102Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6951 8.76484L15.6672 12.7872C15.3056 14.4803 13.801 15.75 12 15.75L11.9639 15.7499L7.54799 19.2825C8.8673 20.1396 10.3745 20.75 12 20.75C14.1409 20.75 16.0767 19.691 17.6482 18.4043C19.2283 17.1106 20.5204 15.5214 21.3886 14.312L21.4602 14.2124C21.9828 13.4862 22.4131 12.8884 22.4131 12C22.4131 11.1117 21.9828 10.5139 21.4602 9.78762L21.3886 9.68804C21.181 9.39894 20.9492 9.08813 20.6951 8.76484Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnshow);
export default __webpack_public_path__ + "static/media/unshow.95064f0430a9a0dc89729bcb916d606b.svg";
export { ForwardRef as ReactComponent };